import { render, staticRenderFns } from "./RocketSettingsTab.vue?vue&type=template&id=51d20832&scoped=true&"
import script from "./RocketSettingsTab.vue?vue&type=script&lang=js&"
export * from "./RocketSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./RocketSettingsTab.vue?vue&type=style&index=0&id=51d20832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d20832",
  null
  
)

export default component.exports